export const passwordTheme = {
  colorScheme: {
    light: {
      meter: {
        background: 'transparent',
        borderRadius: '4px',
        height: '8px'
      },
      icon: {
        color: '{text.muted.color}'
      },
      overlay: {
        background: 'var(--surface-fill)',
        borderRadius: '8px',
        borderColor: 'var(--surface-stroke-divider)',
        color: '{content.color}',
        padding: '1rem',
        shadow: 'var(--shadow-md)'
      },
      content: {
        gap: '0.5rem'
      },
      strength: {
        weakBackground: 'var(--danger-transparent)',
        mediumBackground: 'var(--warning-transparent)',
        strongBackground: 'var(--success-transparent)'
      }
    },
    dark: {
      meter: {
        background: 'transparent',
        borderRadius: '4px',
        height: '8px'
      },
      icon: {
        color: '{text.muted.color}'
      },
      overlay: {
        background: 'var(--surface-fill)',
        borderRadius: '8px',
        borderColor: 'var(--surface-stroke-divider)',
        color: '{content.color}',
        padding: '1rem',
        shadow: 'var(--shadow-md)'
      },
      content: {
        gap: '0.5rem'
      },
      strength: {
        weakBackground: 'var(--danger-transparent)',
        mediumBackground: 'var(--warning-transparent)',
        strongBackground: 'var(--success-transparent)'
      }
    }
  }
};
